const palette = {
  primary: {
    main: "#FFC94AD9",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#233B33",
    contrastText: "#FFFFFF",
  },
  text: {
    primary: "#FFFFFF",
  },
  success: {
    main: "#0E912C",
  },
  common: {
    black: "#000000",
    white: "#FFFFFF",
  },
};

export default palette;
